/*
 * popup Actions
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 30-Sep-2024
 */

import { createAction } from './index'

export const actionTypes = {
  FLOW_POPUP: 'FLOW_POPUP'

  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request
// @generator action

/** @action
* * Insert a description
* @name doPopup
* @return {object} - The payload object
*/
export const doPopup = (popup, moreInfo) => createAction(actionTypes.FLOW_POPUP, { popup, moreInfo })
